/** Gán chi nhánh cho người dùng (user_branch_access). Empty = tất cả chi nhánh. */
import { apiClient } from "./client";

export const userBranchesApi = {
  get(userId: string): Promise<string[]> {
    return apiClient
      .get<{ branchIds: string[] }>(`/v1/users/${userId}/branches`)
      .then((r) => r.data.branchIds ?? []);
  },
  set(userId: string, branchIds: string[]): Promise<void> {
    return apiClient
      .put(`/v1/users/${userId}/branches`, { branchIds })
      .then(() => undefined);
  },
};

export const userBranchesQueryKeys = {
  of: (userId: string) => ["user-branches", userId] as const,
};
